import React from 'react'

import { Box, Tab, Tabs, useMediaQuery } from '@material-ui/core'

import { SearchBar } from 'components'

import constants from 'constants/index'
import theme from 'theme'

const StatusesTab = ({
  selectedTab,
  setSelectedTab,
  filter,
  preAvaliation,
  searchField = '',
}) => {
  const { TABS } = constants.companySuppliers
  const { STEPS } = constants.tours.thirdPartyManagements

  const isMd = useMediaQuery(theme.breakpoints.down('md'))

  const handleSelectTab = (tab) => {
    if (tab === selectedTab) return
    setSelectedTab(tab)
  }

  return (
    <Box
      id={
        preAvaliation ? STEPS.PRE_AVALIATION.DEFAULT[4] : STEPS.MY_SUPPLIERS[4]
      }
      display="flex"
      flexDirection={isMd ? 'column' : 'row'}
      alignItems={isMd ? 'stretch' : 'center'}
      borderBottom={`1px solid ${theme.palette.divider}`}
    >
      <Box flex={isMd ? 'unset' : '0 0 60%'}>
        <Tabs
          value={selectedTab}
          scrollButtons="auto"
          variant="scrollable"
          textColor="primary"
          indicatorColor="primary"
        >
          {TABS.map((tab) => (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleSelectTab(tab.value)}
            />
          ))}
        </Tabs>
      </Box>
      <Box flex={isMd ? 'unset' : '0 0 40%'} px={2} py={isMd ? 1 : 0}>
        <SearchBar filter={filter} fieldName={searchField} />
      </Box>
    </Box>
  )
}

export default StatusesTab
